<template>
	<div role="region" aria-label="Dokumente">
		<nk-wrapper>
			<nk-title tag="h2" size="xl">
				{{ context.titel }}
			</nk-title>

			<nk-text v-if="context.einleitung">
				{{ context.einleitung }}
			</nk-text>

			<template
				v-if="
					typeof context.dokumente !== 'undefined' && context.dokumente.length
				"
			>
				<nk-nav
					:aria-label="`${context.titel} Dokumente`"
					variant="resources"
					append-icon="download"
					prepend-icon="file"
				>
					<nk-nav-item
						v-for="(dokument, index) in context.dokumente"
						:key="`dokument-${index}`"
						:prepend-icon="getFileIcon(dokument.datei)"
						:link="dokument.link"
						:title="dokument.downloadtext"
						:text="getFileExtension(dokument.datei)"
						:aria-label="`Dokument ${dokument.downloadtext} öffnet in einem neuen Tab`"
						:longtext="dokument.beschreibung"
						target="_blank"
					/>
				</nk-nav>
			</template>
			<template v-else>
				<nk-text>
					<nk-icon icon="alarm" />
					Derzeit liegen keine Ausschreibungen vor.
				</nk-text>
			</template>
		</nk-wrapper>
		<nk-divider spacing="lg" />
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {string} context.einleitung
 * @prop {array} context.dokumente
 */

export default {
	name: 'NkTemplateAusschreibungen',
	mixins: [TemplatesDefault],

	methods: {
		formatTime(time, format) {
			return this.$formatTime(time, format);
		},
		getFileExtension(fileName) {
			const fileExtension = fileName.substr(fileName.lastIndexOf('.') + 1);

			return fileExtension.toUpperCase();
		},
		getFileIcon(fileName) {
			const fileExtension = fileName.substr(fileName.lastIndexOf('.') + 1);

			if (['pdf'].includes(fileExtension)) {
				return 'file-pdf';
			}
			if (['png', 'jpg', 'jpeg', 'gif'].includes(fileExtension)) {
				return 'file-image';
			}
			if (['txt'].includes(fileExtension)) {
				return 'file-txt';
			}
			if (['doc', 'docx'].includes(fileExtension)) {
				return 'file-doc';
			}

			return 'file';
		},
	},
};
</script>
